<mat-toolbar class="fixed top-0 left-0 right-0 z-50 shadow-sm border-b ">
  <div class="max-w-6xl mx-auto w-full flex justify-between items-center px-4" *transloco="let t">
    <!-- Logo und Desktop Navigation -->
    <div class="flex items-center gap-8 ">
      <img src="/logo.png" [alt]="t('COMMON.LOGO_ALT')" class="h-10 w-auto object-contain" id="toolbar-logo" />

      <!-- Desktop Menu -->
      <nav class="hidden md:flex items-center gap-2">

      @for(item of navigationItems; track item.path) {
        <a mat-button [routerLink]="item.path" routerLinkActive="mat-button-active"
          class="mat-app-text-secondary mat-app-nav-item">
          {{ t(item.labelKey) }}
        </a>
      }
      </nav>
    </div>

    <!-- Mobile Menu Button und Theme/User Icons -->
    <div class="flex items-center gap-3">
      <!-- Mobile Menu Button -->
       <div class="md:hidden">
         <button mat-icon-button class="mobile-menu-button" (click)="toggleMobileMenu()"
           [attr.aria-label]="t('NAVIGATION.ARIA.OPEN_MENU')">
           <mat-icon>menu</mat-icon>
         </button>
       </div>

      <!-- Theme Switcher -->
      <app-theme-switcher></app-theme-switcher>

      <!-- User Icon -->
      <button mat-icon-button class="mat-app-button-secondary" [matMenuTriggerFor]="userMenu" [attr.aria-label]="t('NAVIGATION.ARIA.USER_PROFILE')">
        <mat-icon>account_circle</mat-icon>
      </button>

      <!-- User Menu -->
      <mat-menu #userMenu="matMenu">
        <div class="px-4 py-2 mat-app-text-secondary text-sm">
          {{ t('NAVIGATION.LOGGED_IN_AS') }} {{ currentUsername }}
        </div>
        <mat-divider></mat-divider>

        <!-- Language Submenu -->
        <button mat-menu-item [matMenuTriggerFor]="languageMenu">
          <mat-icon>language</mat-icon>
          <span>{{ t('NAVIGATION.LANGUAGE') }}</span>
        </button>

        <mat-divider></mat-divider>
        <a mat-menu-item [routerLink]="['/sign-out']">
          <mat-icon>logout</mat-icon>
          <span>{{ t('NAVIGATION.LOGOUT') }}</span>
        </a>
      </mat-menu>

      <!-- Language Submenu -->
      <mat-menu #languageMenu="matMenu">
        @for (lang of availableLanguages; track lang.id) {
          <button mat-menu-item (click)="changeLanguage(lang.id)" [class.mat-app-nav-active]="currentLanguage === lang.id">
            <mat-icon>{{ currentLanguage === lang.id ? 'check' : '' }}</mat-icon>
            <span>{{ lang.label }}</span>
          </button>
        }
      </mat-menu>
    </div>
  </div>
</mat-toolbar>

<!-- Mobile Drawer -->
<mat-sidenav-container class="md:hidden" *transloco="let t">
  <mat-sidenav #drawer mode="over" [opened]="isMobileMenuOpen" (openedChange)="onDrawerChange($event)"
    class="w-72 md:hidden mat-app-bg-secondary">

    <!-- Drawer Header -->
    <div class="flex justify-between items-center p-4 mat-app-border border-b">
      <h3 class="text-lg font-semibold mat-app-text-primary">{{ t('NAVIGATION.MENU') }}</h3>
      <button mat-icon-button (click)="closeMobileMenu()" [attr.aria-label]="t('NAVIGATION.ARIA.CLOSE_MENU')">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Mobile Navigation -->
    <mat-nav-list class="pt-4">
      @for(item of navigationItems; track item.path) {
      <a mat-list-item [routerLink]="item.path" routerLinkActive="mat-app-nav-active" (click)="closeMobileMenu()"
        class="mat-app-nav-item">
        <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
        <span matListItemTitle>{{ t(item.labelKey) }}</span>
      </a>
      }
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content class="mat-app-bg-primary min-h-full">
    <main class="main-content p-6">
      <router-outlet></router-outlet>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
